import React from "react"
import PropTypes from "prop-types"

import { Popover, Badge } from "antd"
import { WarningTwoTone } from "@ant-design/icons"

import { CATEGORY_COLORS, filterFlagsByAudience, groupFlagsByCategory } from "../../../../lib/billFlags"

const CHILD_FLAGS_MESSAGE = "One or more service bills have flags."

function resolveFlags(props) {
    if (props.flags && typeof props.flags === "object") {
        return { ...props.flags }
    }
    if (props.flagKey && props.message) {
        return { [props.flagKey]: props.message }
    }
    if (props.message) {
        return { __generic: props.message }
    }
    return {}
}

function WarningChip(props) {
    const flagsObj = resolveFlags(props)
    const visibleFlags = filterFlagsByAudience(flagsObj, props.audience || "internal")
    const groups = groupFlagsByCategory(visibleFlags)
    const visibleCount = Object.keys(visibleFlags).length

    if (visibleCount === 0 && !props.childFlags) {
        return null
    }

    const badgeCount = visibleCount + (props.childFlags ? 1 : 0)

    const renderBullets = () => {
        const bullets = []
        groups.forEach((group) => {
            group.items.forEach(({ key, message }) => {
                bullets.push(
                    <p key={key} style={{ color: group.color, margin: 0 }}>
                        • {message}
                    </p>
                )
            })
        })
        if (props.childFlags) {
            bullets.push(
                <p key="__child_flags" style={{ color: CATEGORY_COLORS.green, margin: 0 }}>
                    • {CHILD_FLAGS_MESSAGE}
                </p>
            )
        }
        return bullets
    }

    const renderIcons = () => {
        const icons = groups.map((group) => <WarningTwoTone key={group.category} style={{ fontSize: "18px" }} twoToneColor={group.color} />)
        if (props.childFlags) {
            icons.push(<WarningTwoTone key="__child_flags" style={{ fontSize: "18px" }} twoToneColor={CATEGORY_COLORS.green} />)
        }
        return icons
    }

    return (
        <Popover className="warning-chip" content={<div>{renderBullets()}</div>} placement="topRight" trigger="hover">
            <Badge count={badgeCount} size="small" offset={[-20, 5]}>
                <span className="warning-chip-icons">{renderIcons()}</span>
            </Badge>
        </Popover>
    )
}

WarningChip.propTypes = {
    flags: PropTypes.objectOf(PropTypes.string),
    flagKey: PropTypes.string,
    message: PropTypes.string,
    audience: PropTypes.oneOf(["internal", "external"]),
    childFlags: PropTypes.any,
}

export default WarningChip
